import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { AssessmentScoreResponse } from 'src/types/shared/Assessments';

export const fetchAssessmentScoresByApplicationRequest = createAction(
    'fetchAssessmentScoresByApplicationRequest',
);
export const fetchAssessmentScoresByApplicationSuccess = createAction<AssessmentScoreResponse[]>(
    'fetchAssessmentScoresByApplicationSuccess',
);
export const fetchAssessmentScoresByApplicationFailure = createAction(
    'fetchAssessmentScoresByApplicationFailure',
);

export const fetchAssessmentScoresByApplication = (applicationId: number) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(fetchAssessmentScoresByApplicationRequest());
    try {
        const { data }: Response = await api.get(
            `admin/assessments/scores-by-application/${applicationId}`,
        );

        dispatch(fetchAssessmentScoresByApplicationSuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, fetchAssessmentScoresByApplicationFailure, e as any);
    }
};

interface Response {
    data: AssessmentScoreResponse[];
}
